export default "__VITE_ASSET__BUCz1Vuw__"